import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { classNames } from "../../../../../helpers/classNames";
import Image from "../../../../elements/Image";
import { useState } from "react";
import NoImage from "../../../../../assets/images/no-image.png";

const ImageGridItem = ({ image, index, onClick, onDelete, isSingleCover, uploadingImages = [], uploadingNewImage = false, textClass }) => {
  const [hasError, setHasError] = useState(false);
  const isRegenerationLimitReached = (image.regeneratedCount || 0) >= 2;


  const isImageUploading = image._id && uploadingImages.includes(image._id);

 
  const isNewImageGenerating = !image._id && image.id && uploadingNewImage;

  const isDisabled = isRegenerationLimitReached || isImageUploading || isNewImageGenerating;

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: image.id ?? image._id,
    disabled: isImageUploading || isNewImageGenerating,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const containerClasses = isSingleCover
    ? "w-full max-w-sm aspect-[6/7] lg:aspect-[8/11] rounded-xl overflow-hidden mx-auto shadow-lg cursor-pointer"
    : `w-24 md:w-28 aspect-[6/7] lg:aspect-[8/11] rounded-lg overflow-hidden shadow-md shadow-md-pink/20 hover:shadow-xl hover:shadow-md-pink/20 transition-all duration-300 ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`;

  const imageClasses = "w-full h-full object-cover pointer-events-none";

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={() => {
        if (!isDisabled) {
          onClick(image);
        }
      }}
      className="relative"
    >
      <div className={classNames(containerClasses, "relative group")}>
        {!isSingleCover ? <Image src={image.url} alt={`Image`} classes={classNames("w-full h-full", imageClasses)} /> : <img onError={() => setHasError(true)} src={!hasError ? image.url : NoImage} alt={`Image`} className={classNames("w-full h-full", imageClasses)} />}
        {/* Small regeneration limit indicator in top-left corner */}
        {isRegenerationLimitReached && (
          <div className="absolute top-2 left-2 bg-amber-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow-lg z-20">
            <i className="fa-solid fa-lock text-xs"></i>
          </div>
        )}

        {/* Delete button - hidden when uploading/generating */}
        {!isImageUploading && !isNewImageGenerating && (
          <button
            type="button"
            className={`absolute top-1 right-1 rounded w-6 aspect-square flex items-center justify-center cursor-pointer z-30 
                bg-md-pink text-white transition-all duration-300`}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(image.id ?? image._id);
            }}
          >
            <i className="fa-regular fa-xmark"></i>
          </button>
        )}
      </div>

      <div className={classNames(textClass, "w-full relative text-center text-sm py-1 text-gray-400 font-light")}><strong>{`${index + 1}`}</strong></div>
    </div>
  );
};

export default ImageGridItem;
